import { OelCorrectionMethod } from "../enums/oelCorrectionMethod.enum";
import { TWACorrectionMethod } from "../enums/TWACorrectionMethod.enum";

export class Jurisdiction {
  id: string;
  name: string;
  addedToMySite?: boolean;
  addedAtSelectedOrgLevel?: boolean;
  oelCorrectionMethod?: OelCorrectionMethod;
  twaCorrectionMethod?: TWACorrectionMethod;
  applyTemperatureCorrection: boolean;
  applyPressureCorrection: boolean;
}
